<template>
  <div class="container-box">
    <div class="box" :title="titleMouse">
      <p class="box-title">{{title}}</p>
      <div class="line-white"></div>
      <p class="box-description">{{description}}</p>
      <div class="container">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      required: false
    },
    description: {
      required: false
    },
    titleMouse: {
      required: false
    }
  }
}
</script>
<style scoped>
/* BOX */
.container-box {
  padding: 0.5rem;
}
.box {
  cursor: pointer;
  box-shadow: 0px 3px 5px 0px rgba(184, 175, 184, 1);
  background: url(../assets/travessia_box2.png);
  border-radius: 8px;
}
.box[data-badge]:after {
  content: attr(data-badge);
  background: #ff6600;
  display: inline-block;
  height: 30px;
  position: absolute;
  width: 120px;
  top: -35px;
  right: 15px;
  text-align: center;
  color: white;
  font-weight: 500;
}
.box[data-badge]:before {
  border-top: 25px solid #ff6600;
  border-left: 60px solid transparent;
  border-right: 60px solid transparent;
  content: "";
  height: 0;
  position: absolute;
  top: -5px;
  right: 15px;
}

.line-white {
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
}
.box-title {
  text-align: center;
  font-size: 1.1rem;
  text-align: center;
  padding: 0.5rem;
  color: white;

  font-weight: 600;
}
.box-description {
  text-align: center;
  color: white;
  padding: 10px;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .box {
    margin-bottom: 15px;
  }
}
</style>
